import { render, staticRenderFns } from "./RealtimeSamplesViewer.vue?vue&type=template&id=2806554d&scoped=true&"
import script from "./RealtimeSamplesViewer.vue?vue&type=script&lang=ts&"
export * from "./RealtimeSamplesViewer.vue?vue&type=script&lang=ts&"
import style0 from "./RealtimeSamplesViewer.vue?vue&type=style&index=0&id=2806554d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2806554d",
  null
  
)

export default component.exports